export default "__VITE_ASSET__YJcFQfL7__"